<template>
	<div>
		
		系统信息
		<div style="margin-top:50px;">到期日期：{{ expiringDate }}</div>
		<div style="margin-top:50px;">版本信息：{{ version }}</div>
	
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	export default {
	
		computed: {
			...mapState({ logoImage: state => state.app.factoryLogoUrl, 
			expiringDate: state => state.app.expiringDate,
			version: state => state.app.version}),
		
		},
	}
</script>

<style></style>
